"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _searchDealershipsGetLocationButton = _interopRequireDefault(require("../../styles/search-dealerships-get-location-button.css"));
var _checkProps = _interopRequireDefault(require("../../utils/checkProps"));
var GetLocationButton = function GetLocationButton(_ref) {
  var getLocation = _ref.getLocation,
    locationCtaLabel = _ref.locationCtaLabel,
    comp = _ref.comp,
    theme = _ref.theme;
  if (!(0, _checkProps["default"])(getLocation) || !(0, _checkProps["default"])(locationCtaLabel) || !(0, _checkProps["default"])(comp)) {
    return /*#__PURE__*/_react["default"].createElement("button", {
      type: "button",
      className: _searchDealershipsGetLocationButton["default"].getLocation + " " + theme.buttonsAndNav,
      onClick: function onClick() {
        return getLocation(comp);
      },
      tabIndex: 0
    }, locationCtaLabel);
  }
  return null;
};
var _default = GetLocationButton;
exports["default"] = _default;